import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Commercial from "@/pages/Commercial";
import Pricing from "@/pages/Pricing";
import Estimate from "@/pages/Estimate";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Faq from "@/pages/Faq";
import Reviews from "@/pages/Reviews";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/admin/ProtectedRoute";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/components/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminRequests from "@/pages/admin/AdminRequests";
import AdminRequestDetail from "@/pages/admin/AdminRequestDetail";
import AdminServices from "@/pages/admin/AdminServices";
import AdminPricing from "@/pages/admin/AdminPricing";
import AdminAddOns from "@/pages/admin/AdminAddOns";
import AdminReviews from "@/pages/admin/AdminReviews";
import AdminFaqs from "@/pages/admin/AdminFaqs";
import AdminHomepageImages from "@/pages/admin/AdminHomepageImages";
import AdminAbout from "@/pages/admin/AdminAbout";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminSeo from "@/pages/admin/AdminSeo";
import AdminUsers from "@/pages/admin/AdminUsers";
import ActivityLog from "@/pages/admin/ActivityLog";
import DevDashboard from "@/pages/admin/DevDashboard";
import Analytics from "@/pages/admin/Analytics";
import LandingPage from "@/pages/LandingPage";
import AdminLandingPages from "@/pages/admin/AdminLandingPages";
import AdminLandingPageEditor from "@/pages/admin/AdminLandingPageEditor";
import AdminInternalLinks from "@/pages/admin/AdminInternalLinks";

function App() {
  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            {/* Public site */}
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/commercial-cleaning" element={<Commercial />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/faq" element={<Faq />} />
              <Route path="/reviews" element={<Reviews />} />
              <Route path="/request-estimate" element={<Estimate />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/:slug" element={<LandingPage />} />
            </Route>

            {/* Admin */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute allowedRoles={["owner", "developer"]}>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              {/* Owner-only landing; developer is redirected client-side to /admin/dev */}
              <Route index element={
                <ProtectedRoute allowedRoles={["owner"]}><AdminDashboard /></ProtectedRoute>
              } />
              <Route path="requests" element={<ProtectedRoute allowedRoles={["owner"]}><AdminRequests /></ProtectedRoute>} />
              <Route path="requests/:id" element={<ProtectedRoute allowedRoles={["owner"]}><AdminRequestDetail /></ProtectedRoute>} />
              <Route path="analytics" element={<ProtectedRoute allowedRoles={["owner"]}><Analytics /></ProtectedRoute>} />
              <Route path="services" element={<ProtectedRoute allowedRoles={["owner"]}><AdminServices /></ProtectedRoute>} />
              <Route path="pricing" element={<ProtectedRoute allowedRoles={["owner"]}><AdminPricing /></ProtectedRoute>} />
              <Route path="addons" element={<ProtectedRoute allowedRoles={["owner"]}><AdminAddOns /></ProtectedRoute>} />
              <Route path="reviews" element={<ProtectedRoute allowedRoles={["owner"]}><AdminReviews /></ProtectedRoute>} />
              <Route path="faqs" element={<ProtectedRoute allowedRoles={["owner"]}><AdminFaqs /></ProtectedRoute>} />
              <Route path="homepage-images" element={<ProtectedRoute allowedRoles={["owner"]}><AdminHomepageImages /></ProtectedRoute>} />
              <Route path="about" element={<ProtectedRoute allowedRoles={["owner"]}><AdminAbout /></ProtectedRoute>} />
              <Route path="landing-pages" element={<ProtectedRoute allowedRoles={["owner"]}><AdminLandingPages /></ProtectedRoute>} />
              <Route path="internal-links" element={<ProtectedRoute allowedRoles={["owner"]}><AdminInternalLinks /></ProtectedRoute>} />
              <Route path="landing-pages/new" element={<ProtectedRoute allowedRoles={["owner"]}><AdminLandingPageEditor /></ProtectedRoute>} />
              <Route path="landing-pages/:id" element={<ProtectedRoute allowedRoles={["owner"]}><AdminLandingPageEditor /></ProtectedRoute>} />
              <Route path="settings" element={<ProtectedRoute allowedRoles={["owner"]}><AdminSettings /></ProtectedRoute>} />
              <Route path="seo" element={<ProtectedRoute allowedRoles={["owner"]}><AdminSeo /></ProtectedRoute>} />
              <Route path="users" element={<ProtectedRoute allowedRoles={["owner"]}><AdminUsers /></ProtectedRoute>} />
              <Route path="activity" element={<ProtectedRoute allowedRoles={["owner"]}><ActivityLog /></ProtectedRoute>} />
              <Route path="dev" element={<DevDashboard />} />
            </Route>

            <Route path="*" element={<Home />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </div>
  );
}

export default App;
